document.addEventListener('DOMContentLoaded', function() {
  const descriptionElement = document.getElementById('product-description');
  const showMoreBtn = document.getElementById('show-more-btn');
  const maxLength = 400; // Set the character limit to show initially
  // Check if description has more than maxLength characters
  if (descriptionElement && descriptionElement.innerHTML.length > maxLength) {
    // Get the full HTML content
    const fullText = descriptionElement.innerHTML;
    const truncatedText = fullText.slice(0, maxLength) + '...';
    // Initially set truncated text
    descriptionElement.innerHTML = truncatedText;
    // Show the "Read Full Description" button
    showMoreBtn.style.display = 'inline-block';
    showMoreBtn.addEventListener('click', function() {
      if (showMoreBtn.innerText === 'Read Full Description...') {
        // Show the full HTML description
        descriptionElement.innerHTML = fullText;
        showMoreBtn.innerText = 'Read Less...';
      } else {
        // Show the truncated HTML description
        descriptionElement.innerHTML = truncatedText;
        showMoreBtn.innerText = 'Read Full Description...';
      }
    });
  }
});